import { PropsWithChildren } from 'react';

import { S } from './style';

interface Props extends PropsWithChildren {
  fontColor: string;
  bgColor: string;
}

function Badge({ fontColor, bgColor, children }: Props) {
  return (
    <S.StyledBadge fontColor={fontColor} bgColor={bgColor}>
      {children}
    </S.StyledBadge>
  );
}

export default Badge;
